import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { RouteContextType } from "../../hooks/use-route-context/UseRouteContext";
import { UIViewCategory } from "../../routes/routes";

export function getViewCategories(routeContext: RouteContextType): UIViewCategory[] {
    let categories: UIViewCategory[] = [];


    switch (routeContext.contextObject?.objectType) {
        case eLynxObjectTypeEnum.Group:
        case eLynxObjectTypeEnum.Well:
        case eLynxObjectTypeEnum.TankBattery:
            categories.push(UIViewCategory.Group);
            break;

        case eLynxObjectTypeEnum.Device:
            categories.push(UIViewCategory.Group);
            if (routeContext.wellID) {
                categories.push(UIViewCategory.Well);
            }
            break;

        case eLynxObjectTypeEnum.Tank:
            categories.push(UIViewCategory.Group);
            if (routeContext.tankBatteryID) {
                categories.push(UIViewCategory.TankBattery);
            } else if (routeContext.deviceID) {
                categories.push(UIViewCategory.Device);
            }
            break;

        case eLynxObjectTypeEnum.Tag:
            categories.push(UIViewCategory.Group);
            if (routeContext.deviceID && routeContext.wellID) {
                categories = categories.concat([UIViewCategory.Well, UIViewCategory.Device]);
            } else if (routeContext.deviceID && routeContext.tankID) {
                categories = categories.concat([UIViewCategory.Device, UIViewCategory.Tank]);
            } else if (routeContext.tankBatteryID && routeContext.tankID) {
                categories = categories.concat([UIViewCategory.TankBattery, UIViewCategory.Tank]);
            } else if (routeContext.deviceID) {
                categories.push(UIViewCategory.Device);
            } else if (routeContext.wellID) {
                categories.push(UIViewCategory.Well);
            } else if (routeContext.tankBatteryID) {
                categories.push(UIViewCategory.TankBattery);
            }

            break;

        default:
            return [];

    }

    return categories;
}



export function initViewCategories(routeContext: RouteContextType): UIViewCategory[] {
    let categories: UIViewCategory[] = [];


    switch (routeContext.contextObject?.objectType) {
        case eLynxObjectTypeEnum.Group:
            categories.push(UIViewCategory.Group);
            break;

        case eLynxObjectTypeEnum.Well:
            categories.push(UIViewCategory.Group);
            categories.push(UIViewCategory.Well);
            break;

        case eLynxObjectTypeEnum.TankBattery:
            categories.push(UIViewCategory.Group);
            categories.push(UIViewCategory.TankBattery);            
            break;

        case eLynxObjectTypeEnum.Device:
            categories.push(UIViewCategory.Group);
            if (routeContext.wellID) {
                categories.push(UIViewCategory.Well);
            }
            categories.push(UIViewCategory.Device);
            break;

        case eLynxObjectTypeEnum.Tank:
            categories.push(UIViewCategory.Group);
            if (routeContext.tankBatteryID) {
                categories.push(UIViewCategory.TankBattery);
            } else if (routeContext.deviceID) {
                categories.push(UIViewCategory.Device);
            }
            categories.push(UIViewCategory.Tank);
            break;

        case eLynxObjectTypeEnum.Tag:
            categories.push(UIViewCategory.Group);
            if (routeContext.deviceID && routeContext.wellID) {
                categories = categories.concat([UIViewCategory.Well, UIViewCategory.Device]);
            } else if (routeContext.deviceID && routeContext.tankID) {
                categories = categories.concat([UIViewCategory.Device, UIViewCategory.Tank]);
            } else if (routeContext.tankBatteryID && routeContext.tankID) {
                categories = categories.concat([UIViewCategory.TankBattery, UIViewCategory.Tank]);
            } else if (routeContext.deviceID) {
                categories.push(UIViewCategory.Device);
            } else if (routeContext.wellID) {
                categories.push(UIViewCategory.Well);
            } else if (routeContext.tankBatteryID) {
                categories.push(UIViewCategory.TankBattery);
            }
            categories.push(UIViewCategory.Tag);

            break;

        default:
            return [];

    }

    return categories;
}